import BG_ACTIONS from "../actions/BillingGroupActions";
import _ from "lodash";
import SortDirection from "../../../common/constants/SortDirection";
import { BGSortFields } from "../constants/BillingGroupActionConstants";
import { listPageGlobalFilter } from "../../../common/utils/FilterFunctions";
import BG_COUNTRY_PRICING_ACTIONS from "../actions/BillingGroupPricingActions";

const initialState = {
    // Billing group list
    all_billing_groups: [],
    filtered_all_billing_groups: [],
    bgSortKey: BGSortFields.BG_NAME,
    bgSortDirection: SortDirection.ASC,
    bgBasePrice: null,
    billingGroupPricingTables: {},
    billingGroup: {},
}



const billingGroupsReducer = (state = initialState, action) => {
    switch (action.type) {

        case BG_ACTIONS.Detail.LOAD_BILLING_GROUP_DETAIL: {
            let newState = _.cloneDeep(state);
            newState.billingGroup = action.payload.billingGroupDetail;
            return newState;
        }

        case BG_ACTIONS.Detail.CLEAR_BILLING_GROUP_DETAIL_PAGE: {
            let newState = _.cloneDeep(state);
            newState.billingGroup = {};
            return newState;
        }

        case BG_ACTIONS.Types.BG_GLOBAL_SEARCH: {
            let newState = _.cloneDeep(state);
            newState.filtered_all_billing_groups = listPageGlobalFilter(action.payload, newState.all_billing_groups);

            return newState;
        }

        case BG_ACTIONS.Types.TOGGLE_BG_SORT: {
            let newState = _.cloneDeep(state);
            newState.bgSortDirection = newState.bgSortDirection === SortDirection.ASC
                ? SortDirection.DESC : SortDirection.ASC;
            // check for sort direction
            if (newState.bgSortDirection === SortDirection.ASC) {
                // check if the requested sort is for a string value
                // separating this out as there might be null values associated with other sortable headers
                if (action.payload === BGSortFields.BG_NAME) {
                    newState.filtered_all_billing_groups = _.sortBy(newState.filtered_all_billing_groups,
                        [s => s[action.payload].toString().toLowerCase()], [action.payload]);
                } else {
                    newState.filtered_all_billing_groups = _.sortBy(newState.filtered_all_billing_groups,
                        [s => s[action.payload]], [action.payload]);
                }
            } else {
                if (action.payload === BGSortFields.BG_NAME) {
                    newState.filtered_all_billing_groups = _.sortBy(newState.filtered_all_billing_groups,
                        [s => s[action.payload].toString().toLowerCase()], [action.payload]).reverse();
                } else {
                    newState.filtered_all_billing_groups = _.sortBy(newState.filtered_all_billing_groups,
                        [s => s[action.payload]], [action.payload]).reverse();
                }
            }
            newState.bgSortKey = action.payload;
            return newState;
        }


        case BG_ACTIONS.Types.LOAD_ALL_BILLING_GROUPS_FOR_LIST_PAGE: {
            let newState = _.cloneDeep(state);
            newState.all_billing_groups = action.payload;
            newState.filtered_all_billing_groups = action.payload;
            return newState;
        }

        // Country Pricing
        case BG_COUNTRY_PRICING_ACTIONS.BGPricingActionTypes.SET_BG_COUNTRY_PRICING: {
            let newState = _.cloneDeep(state);

            const payloadClone = {...action.payload}
            const {
                BASE_PRICE, FLAT, ...tierPrices
            } = payloadClone;
            const filteredFlat = {
                FLAT: payloadClone.FLAT.filter((item => item.country_code !== 'ZZ'))
            }
            const countryPrices = filteredFlat.FLAT.length ? {...filteredFlat, ...tierPrices} : {...tierPrices};
            newState.bgBasePrice = payloadClone.BASE_PRICE
            newState.billingGroupPricingTables = countryPrices;

            return newState;
        }


        default: return state
    }
}

export default billingGroupsReducer;
